/* eslint-disable react-hooks/exhaustive-deps */
import usePermission from "hooks/usePermission";
import { FunctionComponent, useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { AdyenRoutesName } from "routes/route-names";
import { getRoutePath } from "routes/route-utils";
import { PermissionEnum } from "TypesAndInterfaces";
import "./Menu.scss";

interface IProps {
  opened: boolean;
}

interface IMenuItems {
  name: string;
  path: string;
  icon: string;
}

const initialMenuItems: IMenuItems[] = [
  {
    name: "Marketplaces",
    path: getRoutePath(AdyenRoutesName.DASHBOARD_MARKETPLACES),
    icon: "icon-marketplaces",
  },
  {
    name: "Reports",
    path: getRoutePath(AdyenRoutesName.DASHBOARD_REPORTS),
    icon: "icon-reports",
  },
  {
    name: "Users",
    path: getRoutePath(AdyenRoutesName.DASHBOARD_USERS),
    icon: "icon-users",
  },
];

/*
PUNE OPENED BY DEFAULT FALSE
*/
const Menu: FunctionComponent<IProps> = ({ opened = false }) => {
  const location = useLocation();
  const [menuItems, setMenuItems] = useState(initialMenuItems);
  const { isAuthorized: canViewReports } = usePermission(
    PermissionEnum.VIEW_REPORTS
  );

  const renderLink = ({ name, path, icon }: IMenuItems) => {
    const isActive = location.pathname === path;
    return (
      <li className="nav-menu__list__item" key={name}>
        <Link
          to={path}
          className={"nav-menu__list__item__link " + (isActive && "active")}
        >
          <span className={`nav-menu__list__item__link__icon ${icon}`}></span>
          <span className="nav-menu__list__item__link__text">{name}</span>
        </Link>
      </li>
    );
  };

  useEffect(() => {
    if (!canViewReports) {
      const filtered = menuItems.filter(
        (item) => item.path !== getRoutePath(AdyenRoutesName.DASHBOARD_REPORTS)
      );
      setMenuItems(filtered);
    }
  }, [canViewReports]);

  return (
    <aside className={`main-sidebar ${opened ? "opened" : "closed"}`}>
      <nav className="nav-menu">
        <ul className="nav-menu__list">
          {menuItems.flatMap((item) => renderLink(item))}
        </ul>
      </nav>
    </aside>
  );
};

export default Menu;
